module.exports = __webpack_public_path__ + "img/video_icon.b691a10a.svg";